import useControlType from '../hooks/useControlType';
import useZoom from '../hooks/useZoom';
import { OrbitControls, Html, DeviceOrientationControls } from '@react-three/drei';

export default function Controls({ enableZoom = false, lockY = false }) {
  const controlType = useControlType();
  const isAndroid = /Android/.test(navigator.userAgent);
  
  // Hook de zoom (funciona con cualquier control)
  useZoom(enableZoom);
  
  // Por defecto DeviceControls (mientras detecta o si tiene gyro)
  // Solo cambiar a OrbitControls si la detección confirmó que no hay gyro
  if (controlType === 'orbit') {
    return (
      <>
        {/* <Html position={[0, 0, 0]} center style={{ position: 'fixed', top: '10px', left: '10px', background: 'rgba(0,0,0,0.8)', color: 'lime', padding: '10px', fontSize: '12px', fontFamily: 'monospace', pointerEvents: 'none' }}>
          <div>isAndroid: {String(isAndroid)}</div>
          <div>controlType: {controlType}</div>
          <div>smoothness: {smoothness}</div>
          <div>Control: OrbitControls</div>
          </Html> */}
        <OrbitControls 
          enableDamping 
          dampingFactor={0.05} 
          enableZoom={false} 
          enablePan={false}
          enableRotate={!lockY} // por ahora uso eso porque es el caso de la experiencia exterior
          minPolarAngle={lockY ? Math.PI / 2 : 0}
          maxPolarAngle={lockY ? Math.PI / 2 : Math.PI}
        />
      </>
    );
  }
  
  return (
    <>
      {/* <Html position={[0, 0, 0]} center style={{ position: 'fixed', top: '10px', left: '10px', background: 'rgba(0,0,0,0.8)', color: 'lime', padding: '10px', fontSize: '12px', fontFamily: 'monospace', pointerEvents: 'none' }}>
        <div>isAndroid: {String(isAndroid)}</div>
        <div>controlType: {controlType || 'detecting...'}</div>
        <div>smoothness: {smoothness}</div>
        <div>Control: DeviceOrientationControls (drei) + Zoom</div>
      </Html> */}
      <DeviceOrientationControls 
          alphaOffset={isAndroid ? -0.01 : 0}
      />
    </>
  );
}
